import { Component, Input, OnInit, OnDestroy, Inject} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FileViewExplorerComponent } from 'src/app/file-view-explorer/file-view-explorer.component';
import { CommonService } from 'src/app/services/common.service';
import { TabChangeService } from 'src/app/services/tab-change.service';
import { ModalTabVisibilityService } from '../../services/modal-tab-visibility.service';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-otherinfo',
  templateUrl: './otherinfo.component.html',
  styleUrls: ['./otherinfo.component.scss']
})
export class OtherinfoComponent implements OnInit, OnDestroy {
//@Input() CaseDetails={}
islabadmin:boolean = false;

  // Display name mapping for property names without DisplayName attribute
  private readonly displayNameMap: { [key: string]: string } = {
    // Properties that already have DisplayName in some XMLs (for fallback)
    'ResultValue': 'Result Value',
    'ReferenceRange': 'Reference Range',
    'ResultComments': 'Result Comments',
    'DilutionVolume': 'Dilution Volume',
    'RangeComments': 'Range Comments',
    'DilutionComments': 'Dilution Comments',
    'IsResultRevised': 'Is Result Revised',
    'PatientRace': 'Patient Race',
    'PatientEthnicity': 'Patient Ethnicity',
    'Patient race': 'Patient Race',
    'FirstTest': 'First Test',
    'EmployedinHealthcare': 'Employed in Healthcare',
    'SymptomaticasdefinedbyCDC': 'Symptomatic as defined by CDC',
    'IfYesDateofSymptomOnset': 'If Yes, Date of Symptom Onset',
    'Residentinacongregatecaresetting': 'Resident in a congregate care setting',
    // Properties that typically don't have DisplayName
    'GrossDescription': 'Gross Description',
    'color': 'Color',
    'length': 'Length',
    'fixative': 'Fixative',
    'cores': 'Cores',
    'units': 'Units',
    'dimension': 'Dimension',
    'fragments': 'Fragments',
    'DiagnosisType': 'Diagnosis Type',
    'code': 'Code',
    'interpretation': 'Interpretation',
    'MicroscopicNotes': 'Microscopic Notes',
    'ReportToCancerRegistry': 'Report To Cancer Registry',
    'totalcellsanalyzed': 'Total Cells Analyzed',
    'SpecimenComments': 'Specimen Comments',
    'IsAbnormal': 'Is Abnormal',
    'MappingCode': 'Mapping Code',
    'ClinicalHistory': 'Clinical History',
    'CommentCodes': 'Comment Codes',
    'RefData': 'Reference Data',
    'CTNGComments': 'CTNG Comments',
    'Trichomonas vaginalis': 'Trichomonas Vaginalis',
    'TrichomonasvaginalisComments': 'Trichomonas Vaginalis Comments',
    'CandidaGlabrataComments': 'Candida Glabrata Comments',
    'BacterialVaginosisComments': 'Bacterial Vaginosis Comments',
    'MycoplasmaGenitaliumRESULT': 'Mycoplasma Genitalium Result',
    'MycoplasmaGenitaliumCOMMENTS': 'Mycoplasma Genitalium Comments',
    'IsABNProvided': 'Is ABN Provided',
    'ReflexiveTesting': 'Reflexive Testing',
    'Patientis': 'Patient Is',
    'No of blocks ?': 'No. of Blocks',
    'DiagnosisSummary': 'Diagnosis Summary',
    'gleasonscore': 'Gleason Score',
    'totalcorelength': 'Total Core Length',
    'percentageinvolvement': 'Percentage Involvement',
    'tumorlength': 'Tumor Length',
    'generalcategory': 'General Category'
  };

  // Special display keys - these will be shown as separate full-width boxes instead of key-value pairs
  // Configurable: add more keys here to display them as special boxes
  private readonly specialDisplayKeys: string[] = [
    'interpretation',
    'MicroscopicNotes',
    'DiagnosisSummary'
  ];

  // Display value mapping for values - case-insensitive lookup
  // Maps raw values to user-friendly display values
  private readonly displayValueMap: { [key: string]: string } = {
    // Flag/Result values
    'notdetected': 'Not Detected',
    'detected': 'Detected',
    'indeterminate': 'Indeterminate',
    // Boolean values
    'false': 'No',
    '0': 'No',
    // Color values
    'blue': 'Blue',
    'grey': 'Grey',
    'tan/brown': 'Tan/Brown',
    'yellow': 'Yellow',
    // Other values
    'symptoms': 'Symptoms',
    'mm': 'mm',
    'not applicable': 'Not Applicable'
  };

  // Display heading mapping for Type + SubType combinations - case-insensitive lookup
  // Maps "Type SubType" raw combinations to user-friendly display headings
  private readonly displayHeadingMap: { [key: string]: string } = {
    'tc grossing': 'TC Grossing',
    'pc diagnosis': 'PC Diagnosis',
    'pc results': 'PC Results',
    'surgical diagnosis': 'Surgical Diagnosis',
    'gihistology diagnosis': 'GI Histology Diagnosis',
    'fish diagnosis': 'FISH Diagnosis',
    'gynmolecular results': 'GYN Molecular Results',
    'clinical results': 'Clinical Results',
    'order clinical': 'Order Clinical'
  };

  // Modal tab management
  private destroy$ = new Subject<void>();
  private tabChangeSubscription: Subscription;
  private componentName = 'case 360 prime';
  private isActiveTab = true;
  private modalWasOpen = false;
  private currentModalRefs: any[] = [];

  constructor(
    private service: CommonService,
    private toastr: ToastrService,
    private _formBuilder: FormBuilder,
    private ngxUiLoaderService: NgxUiLoaderService,
    private modalService: NgbModal,
    @Inject('caseData') public CaseDetails: any,
    private tabChangeService: TabChangeService,
    private modalTabVisibility: ModalTabVisibilityService
  ) { }
  ngOnInit(){
    // Subscribe to tab changes
    this.tabChangeSubscription = this.tabChangeService.tabChange$.pipe(
      takeUntil(this.destroy$)
    ).subscribe((tabName: string) => {
      this.isActiveTab = tabName.toLowerCase() === this.componentName.toLowerCase();
      setTimeout(() => {
        if (this.isActiveTab) {
          this.modalTabVisibility.hideForeignOwnedModals('data-case360-modal');
          this.showModals();
        } else {
          this.hideModals();
        }
      }, 0);
    });
    
    // console.log(this.CaseDetails);
    // console.log(JSON.stringify(this.CaseDetails));
    this.islabadmin=this.CaseDetails['islabadmin'];
  }
  
  ngOnDestroy() {
    // Close all open modals when component is destroyed
    if (this.currentModalRefs && this.currentModalRefs.length > 0) {
      this.currentModalRefs.forEach(modalRef => {
        if (modalRef) {
          try {
            modalRef.close();
          } catch (e) {
            // Modal might already be closed, ignore error
          }
        }
      });
      this.currentModalRefs = [];
    }
    
    this.destroy$.next();
    this.destroy$.complete();
    if (this.tabChangeSubscription) {
      this.tabChangeSubscription.unsubscribe();
    }
  }
  viewCaseFile(report,reportType){
    if(report.File !== undefined){
      report = report.File
    }
    let location
    if(this.CaseDetails['ServiceProvider'].length>0){
      location= this.CaseDetails['ServiceProvider'].find(value => value.Location.AccountType=="Laboratory")
        if(location !== undefined){
          location = location.Location
        }
      }else{
      location= this.CaseDetails['ServiceProvider'].Location
    }

    let obj=
      {
        "RequestID": report.PresentationData,
        "Type": report.Category,
        "RequestGUID": report.FileGUID,
        "LabOrgGUID":location.OrganizationGUID,
        "CaseGUID": this.CaseDetails['CaseGUID'],
        "DeploymentsKey":this.CaseDetails['DeploymentKey']
      }
this.ngxUiLoaderService.start()
    this.service.viewCases360DXReport(obj).subscribe(data=>{
      this.ngxUiLoaderService.stop()
      if(data.StatusMessage.toLowerCase() !== "failed"){
        if(data['FileContent'] !== null){

          'data:application/pdf;base64,'+data['FileContent']
          let namemodal={
            name:report.ReportName,
            fullfile:data['FileContent']
          }
          const modalRef = this.modalService.open(FileViewExplorerComponent
            , {
            windowClass: "myCustomModalViewfilecase360",
            backdrop: "static",
            keyboard: false
          });
          modalRef.componentInstance.fileData =namemodal ;
          this.currentModalRefs.push(modalRef);
          
          modalRef.result.then(() => {
            this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
          }, (reason) => {
            this.currentModalRefs = this.currentModalRefs.filter(ref => ref !== modalRef);
          });
          
          // Add data attribute to identify the modal and backdrop
          this.modalTabVisibility.tagOwned('data-case360-modal', 'myCustomModalViewfilecase360');
          
          this.modalWasOpen = true;
          this.service.auditsave("View", "", "Viewed"+reportType+" :-"+report.FileName, "case", this.CaseDetails['CaseGUID'], "Other info tab ,deployment key :-"+this.CaseDetails.DeploymentKey);
              }else{
                this.ngxUiLoaderService.stop();
                this.toastr.warning('Data not Found', "Alert", {
                  positionClass: "toast-bottom-right",
                  timeOut: 4000,
                });
              }
      }else{
        this.ngxUiLoaderService.stop();
        this.service.copyableToastError(data.FileContent,'Failed');
      }

    },error=>{
      this.ngxUiLoaderService.stop()
    })
  }
  get clinicalHistoryValue(): string {
    try {
      const observationDetails = this.CaseDetails?.OrderDetails?.ObservationDetails;
      
      if (!observationDetails || !Array.isArray(observationDetails)) {
        return '';
      }
      
      const clinicalObs = observationDetails.find(
        obs => obs?.Type === 'Order' && obs?.SubType === 'Clinical'
      );
      
      if (!clinicalObs?.Observation) {
        return '';
      }
      
      return clinicalObs.Observation.Name === 'ClinicalHistory' 
        ? clinicalObs.Observation.Value || '' 
        : '';
    } catch (error) {
      console.warn('Error accessing clinical history:', error);
      return '';
    }
  }

  /**
   * Extracts test results from Tests that have ObservationDetails with Type="pc" and SubType="Results"
   * Returns array of result groups, each with heading (TestName) and observations
   */
  get testResultSections(): any[] {
    try {
      const results: any[] = [];
      const resultDetails = this.CaseDetails?.ResultDetails?.Result;
      if (!resultDetails) return [];

      // Get ObservationSet(s) - can be single object or array
      const observationSets = this.toArray(resultDetails.ObservationSet);
      
      for (const obsSet of observationSets) {
        const testDetails = obsSet?.TestDetails?.Test;
        if (!testDetails) continue;

        const tests = this.toArray(testDetails);
        
        for (const test of tests) {
          // Skip Tests with OrderCodeType="Panel" (case-insensitive)
          if ((test?.OrderCodeType || '').toLowerCase() === 'panel') continue;

          const obsDetailsArr = this.toArray(test?.ObservationDetails);
          
          for (const obsDetails of obsDetailsArr) {
            const observations = this.toArray(obsDetails?.Observation);
            if (observations.length === 0) continue;

            // Check Type/SubType on ObservationDetails OR on individual Observations
            const obsDetailsMatch = this.matchesTypeAndSubType(obsDetails, 'pc', 'results');
            const observationsMatch = observations.some(obs => this.matchesTypeAndSubType(obs, 'pc', 'results'));
            
            if (obsDetailsMatch || observationsMatch) {
              const heading = test.TestName || 'Test Results';
              const section = this.buildObservationSection(heading, observations);
              if (section) results.push(section);
            }
          }
        }
      }
      
      return results;
    } catch (error) {
      console.warn('Error extracting test results:', error);
      return [];
    }
  }

  /**
   * Extracts results from ObservationDetails inside ObservationSet but outside Test nodes
   * Priority: Type="pc" (SubType="Results" or "Diagnosis"), skip others when priority exists
   * For Diagnosis: heading = SiteName + " Diagnosis"
   * For Results: heading = Type + " " + SubType
   */
  get observationSetResultSections(): any[] {
    try {
      const results: any[] = [];
      const resultDetails = this.CaseDetails?.ResultDetails?.Result;
      if (!resultDetails) return [];

      const observationSets = this.toArray(resultDetails.ObservationSet);
      
      for (const obsSet of observationSets) {
        // Get SiteName from Specimen
        const specimen = obsSet?.SpecimenDetails?.Specimen;
        const siteName = Array.isArray(specimen) ? specimen[0]?.SiteName : specimen?.SiteName;

        // Look for ObservationDetails directly in ObservationSet (not inside Test)
        const obsDetailsArr = this.toArray(obsSet?.ObservationDetails);
        
        // Check if priority ObservationDetails exist (Type="pc" with Results or Diagnosis)
        const hasPriorityResults = obsDetailsArr.some(od => this.matchesTypeAndSubType(od, 'pc', 'results'));
        const hasPriorityDiagnosis = obsDetailsArr.some(od => this.matchesTypeAndSubType(od, 'pc', 'diagnosis'));
        
        for (const obsDetails of obsDetailsArr) {
          const obsType = (obsDetails?.Type || '').toLowerCase();
          const obsSubType = (obsDetails?.SubType || '').toLowerCase();
          
          // Skip non-priority ObservationDetails when priority ones exist
          if ((hasPriorityResults || hasPriorityDiagnosis) && 
              !(obsType === 'pc' && (obsSubType === 'results' || obsSubType === 'diagnosis'))) {
            continue;
          }
          
          const observations = this.toArray(obsDetails?.Observation);
          if (observations.length === 0) continue;

          // Determine heading based on type
          let heading: string;
          if (obsType === 'pc' && obsSubType === 'diagnosis') {
            heading = (siteName || 'Site') + ' Diagnosis';
          } else {
            heading = this.getDisplayHeading(obsDetails?.Type, obsDetails?.SubType);
          }
          
          const section = this.buildObservationSection(heading, observations);
          if (section) results.push(section);
        }
      }
      
      return results;
    } catch (error) {
      console.warn('Error extracting observation set results:', error);
      return [];
    }
  }

  /**
   * Extracts ALL ObservationDetails at Result level (outside ObservationSet)
   * Heading = Type + " " + SubType
   */
  get standaloneResultSections(): any[] {
    try {
      const results: any[] = [];
      const resultDetails = this.CaseDetails?.ResultDetails?.Result;
      if (!resultDetails) return [];

      // Look for ObservationDetails directly under Result (not inside ObservationSet)
      const obsDetailsArr = this.toArray(resultDetails.ObservationDetails);
      
      for (const obsDetails of obsDetailsArr) {
        const observations = this.toArray(obsDetails?.Observation);
        if (observations.length === 0) continue;

        // Heading = Type + SubType (with display mapping)
        const heading = this.getDisplayHeading(obsDetails?.Type, obsDetails?.SubType);
        
        const section = this.buildObservationSection(heading, observations);
        if (section) results.push(section);
      }
      
      return results;
    } catch (error) {
      console.warn('Error extracting standalone results:', error);
      return [];
    }
  }

  /**
   * Extracts special display keys (interpretation, MicroscopicNotes, DiagnosisSummary)
   * These are shown as separate full-width boxes with heading = SiteName + " " + MappedKeyName
   * Returns array of { heading: string, value: string }
   */
  get specialResultSections(): any[] {
    try {
      const results: any[] = [];
      const resultDetails = this.CaseDetails?.ResultDetails?.Result;
      if (!resultDetails) return [];

      const observationSets = this.toArray(resultDetails.ObservationSet);
      
      for (const obsSet of observationSets) {
        // Get SiteName from Specimen
        const specimen = obsSet?.SpecimenDetails?.Specimen;
        const siteName = Array.isArray(specimen) ? specimen[0]?.SiteName : specimen?.SiteName;
        const sitePrefix = siteName || 'Site';

        // Collect all observations from this ObservationSet
        const allObservations: any[] = [];
        
        // From ObservationDetails directly in ObservationSet
        const obsDetailsArr = this.toArray(obsSet?.ObservationDetails);
        for (const obsDetails of obsDetailsArr) {
          const observations = this.toArray(obsDetails?.Observation);
          allObservations.push(...observations);
        }
        
        // From ObservationDetails inside Tests
        const testDetails = obsSet?.TestDetails?.Test;
        if (testDetails) {
          const tests = this.toArray(testDetails);
          for (const test of tests) {
            const testObsDetailsArr = this.toArray(test?.ObservationDetails);
            for (const obsDetails of testObsDetailsArr) {
              const observations = this.toArray(obsDetails?.Observation);
              allObservations.push(...observations);
            }
          }
        }

        // Extract special keys from observations
        for (const obs of allObservations) {
          const name = obs?.Name || '';
          if (this.isSpecialDisplayKey(name)) {
            const value = (obs?.Value || '').trim();
            // Only add if value is not empty
            if (value) {
              const displayName = this.getDisplayName(obs?.DisplayName, name);
              results.push({
                heading: sitePrefix + ' ' + displayName,
                value: value
              });
            }
          }
          
          // Also check Property children for special keys
          const propElements = this.toArray(obs?.Property);
          for (const prop of propElements) {
            const propName = prop?.Name || '';
            if (this.isSpecialDisplayKey(propName)) {
              const propValue = (prop?.Value || '').trim();
              if (propValue) {
                const propDisplayName = this.getDisplayName(prop?.DisplayName, propName);
                results.push({
                  heading: sitePrefix + ' ' + propDisplayName,
                  value: propValue
                });
              }
            }
          }
        }
      }

      // Also check standalone ObservationDetails (outside ObservationSet)
      const standaloneObsDetails = this.toArray(resultDetails.ObservationDetails);
      for (const obsDetails of standaloneObsDetails) {
        const observations = this.toArray(obsDetails?.Observation);
        for (const obs of observations) {
          const name = obs?.Name || '';
          if (this.isSpecialDisplayKey(name)) {
            const value = (obs?.Value || '').trim();
            if (value) {
              const displayName = this.getDisplayName(obs?.DisplayName, name);
              // For standalone, use just the display name as heading
              results.push({
                heading: displayName,
                value: value
              });
            }
          }
        }
      }
      
      return results;
    } catch (error) {
      console.warn('Error extracting special result sections:', error);
      return [];
    }
  }

  /**
   * Helper: Convert value to array (handles both single object and array)
   */
  private toArray(value: any): any[] {
    if (!value) return [];
    return Array.isArray(value) ? value : [value];
  }

  /**
   * Helper: Check if ObservationDetails matches Type and SubType (case-insensitive)
   */
  private matchesTypeAndSubType(obsDetails: any, type: string, subType: string): boolean {
    if (!obsDetails) return false;
    const obsType = (obsDetails.Type || '').toLowerCase();
    const obsSubType = (obsDetails.SubType || '').toLowerCase();
    return obsType === type.toLowerCase() && obsSubType === subType.toLowerCase();
  }

  /**
   * Helper: Build a section from observations, detecting structure automatically
   * If observations have Property children → sub-groups with CodeName as heading
   * If observations have Name/Value directly → flat key-value list
   */
  private buildObservationSection(heading: string, observations: any[]): any {
    if (!observations || observations.length === 0) return null;

    // Detect structure: check if any observation has Property children
    const hasPropertyChildren = observations.some(obs => obs.Property);
    
    if (hasPropertyChildren) {
      // Sub-groups: use CodeName as heading, extract Properties
      const subGroups: any[] = [];
      for (const obs of observations) {
        const subHeading = obs.CodeName || obs.Name || 'Result';
        const properties = this.extractProperties(obs);
        if (properties.length > 0) {
          subGroups.push({ heading: subHeading, properties });
        }
      }
      if (subGroups.length > 0) {
        return { heading, hasSubGroups: true, subGroups };
      }
    } else {
      // Flat: extract Name/Value directly from observations
      const properties: any[] = [];
      for (const obs of observations) {
        // Skip special display keys - they are shown as separate boxes
        if (this.isSpecialDisplayKey(obs.Name)) continue;
        
        const key = this.getDisplayName(obs.DisplayName, obs.Name);
        const rawValue = obs.Value || '';
        // Only add if both key and value are present (skip empty values)
        if (key && rawValue) {
          const value = this.getDisplayValue(rawValue);
          properties.push({ key, value });
        }
      }
      if (properties.length > 0) {
        return { heading, hasSubGroups: false, properties };
      }
    }
    
    return null;
  }

  /**
   * Helper: Get display name from mapping only
   * Priority: Mapped name > Original name (DisplayName is ignored)
   * If no mapping, capitalize the first letter
   */
  private getDisplayName(displayName: string, name: string): string {
    if (name && this.displayNameMap[name]) return this.displayNameMap[name];
    if (!name) return '';
    // Capitalize first letter when no mapping is available
    return name.charAt(0).toUpperCase() + name.slice(1);
  }

  /**
   * Helper: Get display value from mapping (case-insensitive)
   * Priority: Mapped value > Original value
   */
  private getDisplayValue(value: string): string {
    if (!value) return '';
    const trimmedValue = value.trim();
    if (!trimmedValue) return '';
    const lowerValue = trimmedValue.toLowerCase();
    if (this.displayValueMap[lowerValue]) return this.displayValueMap[lowerValue];
    return trimmedValue;
  }

  /**
   * Helper: Get display heading from Type + SubType (case-insensitive)
   * Priority: Mapped heading > Original "Type SubType"
   */
  private getDisplayHeading(type: string, subType: string): string {
    const combined = ((type || '') + ' ' + (subType || '')).trim();
    if (!combined) return 'Results';
    const lowerCombined = combined.toLowerCase();
    if (this.displayHeadingMap[lowerCombined]) return this.displayHeadingMap[lowerCombined];
    return combined;
  }

  /**
   * Helper: Check if a key should be displayed as a special full-width box
   * Case-insensitive comparison
   */
  private isSpecialDisplayKey(name: string): boolean {
    if (!name) return false;
    return this.specialDisplayKeys.some(key => 
      key.toLowerCase() === name.toLowerCase()
    );
  }

  /**
   * Helper: Extract properties from an Observation element
   * Uses DisplayName (fallback to mapping, then Name) as key, Value as value
   * Skips special display keys (they are handled separately)
   */
  private extractProperties(observation: any): any[] {
    const properties: any[] = [];
    if (!observation) return properties;

    // Check for Property elements (can be single or array)
    const propElements = this.toArray(observation.Property);
    
    for (const prop of propElements) {
      // Skip special display keys - they are shown as separate boxes
      if (this.isSpecialDisplayKey(prop.Name)) continue;
      
      const key = this.getDisplayName(prop.DisplayName, prop.Name);
      const rawValue = prop.Value || '';
      // Only add if both key and value are present (skip empty values)
      if (key && rawValue) {
        const value = this.getDisplayValue(rawValue);
        properties.push({ key, value });
      }
    }
    
    return properties;
  }
  
  hideModals() {
  const result = this.modalTabVisibility.hideOwned('data-case360-modal', {
    hasOpenRefs: this.currentModalRefs?.length > 0,
    windowClasses: ["myCustomModalClasscase360audit","myCustomModalViewfilecase360","myCustomModalClasscase360hl7","myCustomModalClassFTPcase360","myCustomModalClasscase360","Mode_Bootcase360","viewstagescasemsg360","viewstagescase360","messageiotcase360","PopupScreencase360"],
    nestedOwnerAttrs: ['data-case360-nested-modal'],
  });
  this.modalWasOpen = result.modalWasOpen;
}

showModals() {
  this.modalTabVisibility.showOwned('data-case360-modal', {
    modalWasOpen: this.modalWasOpen,
    hasOpenRefs: this.currentModalRefs?.length > 0,
    windowClasses: ["myCustomModalClasscase360audit","myCustomModalViewfilecase360","myCustomModalClasscase360hl7","myCustomModalClassFTPcase360","myCustomModalClasscase360","Mode_Bootcase360","viewstagescasemsg360","viewstagescase360","messageiotcase360","PopupScreencase360"],
    nestedOwnerAttrs: ['data-case360-nested-modal'],
  });
}
}
